import React from "react";
import { Link } from "gatsby"
import { slide as Menu } from "react-burger-menu";

export default props => {
  return (
    <Menu right {...props}>
      <Link to="/" className="menu-item" >
        Home
      </Link>

      <Link to="/app" className="menu-item" >
        アプリ
        </Link>

        <Link to="/info" className="menu-item" >
        お知らせ
        </Link>

        <Link to="/help-web" className="menu-item" >
        ヘルプ
        </Link>
    </Menu>
  );
};